import React from "react";

export const ImageDetailsList = ({ className, children }) => {
    return <ul className={className}>{children}</ul>;
};

export const ImageListItem = ({ className, children }) => {
    return <li className={className}>{children}</li>;
};
